import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';

@Component({
    selector: 'mobile-terms-dialog',
    templateUrl: './terms-dialog.component.html',
    styleUrls: ['./terms-dialog.component.scss']
})
export class MobileTermsDialogComponent implements OnInit {
    constructor(private dialogRef: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {}


    private _isPopup: boolean = false;
    public get isPopup(): boolean {
        return this._isPopup;
    }
    public set isPopup(value: boolean) {
        this._isPopup = value;
    }

    public get title(): string {
        if (this.data.title != null) {
            return this.data.title;
        }
        return "";
    }

    ngOnInit() {
        
    }

    closeAction() {
        if (this.isPopup)
            this.dialogRef.closeAll();

    }


}